import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import MembershipTrade from "../entities/membershipTrade";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";

interface MembershipTradeState extends ListState<MembershipTrade> {
  editMembershipTrade: MembershipTrade;
  permissions: Array<string>;
  treePermissions: Array<TreePermission>;
  recordList:Array<any>;
}

interface TreePermission {
  title: string;
  checked: boolean;
  expand: boolean;
  children: Array<TreePermission>;
}
class MembershipTradeModule extends ListModule<MembershipTradeState, any, MembershipTrade> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<MembershipTrade>(),
    loading: false,
    editMembershipTrade: new MembershipTrade(),
    permissions: new Array<string>(),
    treePermissions: new Array<TreePermission>(),
    recordList:new Array<any>()
  };
  actions = {
    async getAll(context: ActionContext<MembershipTradeState, any>, payload: any) {
      context.state.loading = true;
      let reponse = await Ajax.get("/api/services/app/MembershipTrade/GetAll", {
        params: payload.data,
      });
      context.state.loading = false;
      let page = reponse.data.result as PageResult<MembershipTrade>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async create(context: ActionContext<MembershipTradeState, any>, payload: any) {
      await Ajax.post(
        "/api/services/app/MembershipTrade/CreateWithImages",
        payload.data
      );
    },
      async toMembershipDemand(
      context: ActionContext<MembershipTradeState, any>,
      payload: any,
    ) {
      console.log(payload,'payload');
      let reponse = await Ajax.get(
        "/api/services/app/MembershipTrade/ToMembershipDemand?Id=" +
          payload.data,
      );
      return reponse.data.result 
    },
    async update(context: ActionContext<MembershipTradeState, any>, payload: any) {
      await Ajax.put(
        "/api/services/app/MembershipTrade/UpdateWithImages",
        payload.data
      );
    },
    async delete(context: ActionContext<MembershipTradeState, any>, payload: any) {
      await Ajax.delete(
        "/api/services/app/MembershipTrade/Delete?Id=" + payload.data.id
      );
    },
    async get(context: ActionContext<MembershipTradeState, any>, payload: any) {
      let reponse = await Ajax.get(
        "/api/services/app/MembershipTrade/Get?Id=" + payload.id
      );
      return reponse.data.result as MembershipTrade;
    },
    async deleteImg(
      context: ActionContext<MembershipTradeState, any>,
      payload: any
    ) {
      return await Ajax.delete(
        "/api/services/app/MembershipTradeImage/Delete?Id=" + payload.data.id
      );
    },
    async getAllPermissions(context: ActionContext<MembershipTradeState, any>) {
      let reponse = await Ajax.get(
        "/api/services/app/MembershipTrade/getAllPermissions"
      );
      context.state.permissions = reponse.data.result.items;
    },
    async getAllListByMembershipTradeId(context: ActionContext<MembershipTradeState, any>, payload: any) {
      context.state.loading = true;
      let reponse = await Ajax.get("/api/services/app/MembershipTradeTrade/GetAllListByMembershipTradeId", {
        params: payload.data,
      });
      context.state.loading = false;
      context.state.totalCount = reponse.data.result.length;
      context.state.recordList =  reponse.data.result;
    },
  };
  mutations = {
    setCurrentPage(state: MembershipTradeState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: MembershipTradeState, pagesize: number) {
      state.pageSize = pagesize;
    },
    edit(state: MembershipTradeState, membershipTrade: MembershipTrade) {
      state.editMembershipTrade = membershipTrade;
    },
  };
}
const membershipTradeModule = new MembershipTradeModule();
export default membershipTradeModule;
